import React, { useEffect } from "react";
import styles from "./Privacypolicy.module.css";
import { Helmet } from "react-helmet-async";

const PrivacyPolicy = () => {
  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scrolling
    });
  }, []); // Empty dependency array ensures this runs only once when component mounts
  return (
    <>
      {/* <Helmet>
        <title>
          Read our privacy and policy - iFillip
        </title>
      </Helmet> */}
      <div className={styles.privacyPage}>
        <div className="container">
          <div className={styles.content}>
            <h1 className={styles.pageTitle}>Privacy Policy</h1>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>
                Bharat Clouds respects and values your trust
              </h2>
              <p className={styles.paragraph}>
                We respect and value your trust and is committed to ensuring
                utmost protection of privacy of its users. Our privacy policy is
                designed keeping in mind the sensitivity of the users and would
                help you to understand how collect, handle and protect the
                personal information that you provide to us during the course of
                using our website, online and mobile application and related
                services.
              </p>
              <p className={styles.paragraph}>
                For purpose of this policy, "website" refers to the product
                website which can be accessed at{" "}
                <a
                  href="https://www.ifillip.com"
                  className={styles.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  www.ifillip.com
                </a>{" "}
                or through our mobile application, which is owned by Bharat
                Clouds Private Limited, a company incorporated under the Indian
                Company Act, 1956. "Service" refers to the services accessed via
                the website. The terms "we," "us," and "us" refer to the website
                and "You" refers to you, as a user of our website or mobile
                application or our Service.
              </p>
              <p className={styles.paragraph}>
                By accessing our product website or using our service, you
                accept our Privacy Policy and you consent to our collection,
                storage, use and disclosure of your Personal Information as
                described in this Privacy Policy.
              </p>
              <p className={styles.paragraph}>
                We do our best to maintain the personal information you give to
                us in a secure, safe and responsible manner. Except as otherwise
                stated in this Privacy Policy, the personal information we
                collect will not be sold, rented or leased.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Collection of information</h2>
              <p className={styles.paragraph}>
                We collect both "Non-Personal Information" and "Personal
                Information". Non-Personal Information includes information that
                cannot be used to personally identify you, such as anonymous
                usage data, general demographic information we may collect,
                referring/exit pages and URLs, platform types, preferences you
                submit and preferences that are generated based on the data you
                submit and number of clicks. Personal Information includes your
                address, email, date of birth, marital status, Govt issued
                identification cards, contact details which you submit to us
                through the registration process at the website. Please note
                that iFillip being a school & learning management
                website-cum-mobile application, personal information is also
                received from school authorities.
              </p>
              <p className={styles.paragraph}>
                To activate the services of iFillip you do not need to submit
                any personal Information other than your email address. It is
                pertinent to reiterate here that the school availing the school
                opting for the services of iFillip may share personal
                information to iFillip to fully utilize the functionalities of
                iFillip. To use the services thereafter, you need not submit any
                further personal Information. However, in an effort to improve
                the quality of the services, we track information provided to us
                by your browser or by our software application when you view or
                use the services such as the website you came from (known as the
                "referring URL"), the type of browser you use, the device from
                which you connected to the Service, the time and date of access,
                and other information that does not personally identify you. We
                track this information using cookies or small text files which
                include an anonymous unique identifier. Cookies are sent to a
                user's browser from our servers and are stored on the user's
                computer hard drive. Sending a cookie to a user's browser
                enables us to collect Non-Personal information about that user
                and keep a record of the user's preferences when utilizing our
                services, both on an individual and aggregate basis. The Company
                may use both persistent and session cookies; persistent cookies
                remain on your computer after you close your session and until
                you delete them, while session cookies expire when you close
                your browser.
              </p>
              <p className={styles.paragraph}>
                The website & mobile application of iFillip is a communication
                bridge between the students, parents, teacher & school
                management meant to improve the overall process of imparting
                education to the students. The website does not knowingly
                collect or solicit information from anyone under the age of 18
                directly or allow anyone under the age of 18 to sign up for the
                service. All services and data collection both in website &
                mobile application of iFillip is collected from or shared by the
                parents or school authorities of those schools that are
                utilizing the services of iFillip. In the event, that we learn
                that we have gathered personal information from anyone under the
                age of 18 without the consent of a parent or guardian, we will
                delete that information as soon as possible. If you believe we
                have collected such information, please contact us at{" "}
                <a href="mailto:info@ifillip.com" className={styles.link}>
                  info@ifillip.com
                </a>
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>
                Onus is on you and school authorities
              </h2>
              <p className={styles.paragraph}>
                It is up to you and your ward(s) school authorities if to
                provide us with personal information by participating in any of
                the activities mentioned in this Privacy Policy. If you choose
                to participate, your personal information will be carefully
                handled in accordance with this Privacy Policy.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>
                We handle Information with utmost care
              </h2>
              <p className={styles.paragraph}>
                We use the information you provide about yourself when
                registering. This allows us to process your information and
                activate your account. We do not share this information with any
                outside parties.
              </p>
              <p className={styles.paragraph}>
                We never use or share the personally identifiable information
                provided to us online in ways unrelated without providing you an
                opportunity to opt-out or otherwise prohibit such unrelated
                uses.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>
                E-mail and direct mail offers
              </h2>
              <p className={styles.paragraph}>
                Being a website & mobile application that puts education at the
                top of things, we may use your e-mail address you have provided
                us to send you information related to education and latest news,
                happenings & trends in that field from time to time that would
                be of interest to you and your wards.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Polls & surveys</h2>
              <p className={styles.paragraph}>
                From time to time, we may randomly contact registered members
                about participating in an online poll or survey about our
                services and/or website. Your feedback helps us identify member
                needs, levels of satisfaction, and improve and/or develop new
                services for you and your family. These surveys are always
                voluntary.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Legal</h2>
              <p className={styles.paragraph}>
                On rare occasions, we may be required to disclose personal
                information pursuant to lawful requests, such as subpoenas or
                court orders, or as required by applicable laws. Also, if the
                ownership of iFillip were to change, member information
                pertinent to that business's operations would likely be
                transferred to, or licensed for use by, the new owner.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Change is constant</h2>
              <p className={styles.paragraph}>
                iFillip is continually improving its services for you. This
                includes adding new functionality and features to its websites.
                Because of these changes, changes in technology and/or the law,
                this Privacy Policy will change from time to time. We encourage
                you to review it each time you visit our website make sure you
                understand our current practices and policies.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>
                Website Usage, Traffic Patterns
              </h2>
              <p className={styles.paragraph}>
                We keep track of member traffic patterns and site usage within
                our website to help us provide superior service and convenient
                access to our services, and improve member access, website
                responsiveness and usefulness of the website. We frequently
                analyse data about our customers, website traffic and/or other
                consumer-related information to improve/tune our website overall
                performance.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Non-personal information</h2>
              <p className={styles.paragraph}>
                When you visit our website, we may collect information about you
                that is not personally identifiable such as the type of internet
                browser or operating system you have, or the domain name of the
                website from which you linked to our site.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Summary</h2>
              <p className={styles.paragraph}>
                Bharat Clouds is committed to protecting the privacy of the
                users of iFillip. The information that we collect on our
                website/application is solely used for disseminating information
                regarding the wards provided by their educational institution
                apart from improving the user experience on our website. We
                strictly do not sell, trade, or rent your personal information
                to others. If we decide to change our privacy policy, we will
                post those changes on this page so that you are always aware of
                what information we collect, how we use it, and under what
                circumstances we disclose it.
              </p>
            </section>

            <section className={styles.section}>
              <h2 className={styles.sectionTitle}>Note</h2>
              <p className={styles.paragraph}>
                If you have any questions or clarifications about our Privacy
                Policy, please e-mail us at{" "}
                <a href="mailto:info@ifillip.com" className={styles.link}>
                  info@ifillip.com
                </a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicy;
